import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/task-type`)
  return data.data
}

export const useTaskTypes = () => {
  const { data, ...props } = useQuery(
    queryKeys.TASK_TYPES,
    () => getData(),
  )
  return { data, ...props }
}
